import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

export const getMatriculados = createAsyncThunk(
  'matriculados/getMatriculados',
  async (arg, { getState, dispatch }) => {
    const { filtersAndSort, page, propsLimit, searchProp } =
      getState().matriculados;

    const query = !searchProp
      ? `${process.env.REACT_APP_SERVER}/users/get-admins?offset=${
          page * propsLimit
        }&limit=${propsLimit}`
      : `${process.env.REACT_APP_SERVER}/users/get-admins?offset=${
          page * propsLimit
        }&limit=${propsLimit}&field=${searchProp}`;

    const { data } = await axios.post(query, filtersAndSort, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    dispatch(setMatriculados(data));
    dispatch(setMatriculadosTotal(data.totalLength));
  }
);

export const matriculadosSlice = createSlice({
  name: 'matriculados',
  initialState: {
    data: [],
    matriculado: null,
    filtersAndSort: {},
    page: 0,
    propsLimit: 10,
    searchProp: '',
    matriculadosTotal: 0,
    editModalId: null
  },
  reducers: {
    setMatriculados: (state, { payload }) => {
      const { users } = payload;
      state.data = users;
    },
    setMatriculado: (state, { payload }) => {
      state.matriculado = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setPropsLimit: (state, { payload }) => {
      state.propsLimit = payload;
    },
    setSearchProp: (state, { payload }) => {
      state.searchProp = payload;
    },
    setMatriculadosTotal: (state, { payload }) => {
      state.matriculadosTotal = payload;
    },
    setEditModalId: (state, { payload }) => {
      state.editModalId = payload;
    },
    setFiltersAndSort: (state, { payload }) => {
      state.filtersAndSort = payload;
    }
  }
});

export const {
  setMatriculados,
  setMatriculado,
  setPage,
  setPropsLimit,
  setSearchProp,
  setMatriculadosTotal,
  setEditModalId,
  setFiltersAndSort
} = matriculadosSlice.actions;

export const createMatriculado = userData => async dispatch => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/create-admin-cucicba`,
      userData
    );
    messageHandler('success', 'Usuario creado correctamente.');
    dispatch(setPage(0));
    dispatch(setPropsLimit(10));
    dispatch(setSearchProp(''));
    dispatch(setFiltersAndSort({}));
    dispatch(getMatriculados());
    return response;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e;
  }
};

export const editMatriculado = (id, userData) => async dispatch => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER}/users/update-admin-cucicba/${id}`,
      userData
    );
    messageHandler('success', 'Usuario editado correctamente.');

    dispatch(setEditModalId(null));
    dispatch(getMatriculados());

    return response;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e;
  }
};

export const resendInvitation = data => async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/users/resend-confirmation`,
      data
    );

    messageHandler('success', response.data.message);
  } catch (e) {
    messageHandler('error', e.response.data.message);
  }
};

export default matriculadosSlice.reducer;
